import { render } from "./Logos.vue?vue&type=template&id=f691b16e&scoped=true&ts=true"
import script from "./Logos.vue?vue&type=script&lang=ts"
export * from "./Logos.vue?vue&type=script&lang=ts"

import "./Logos.vue?vue&type=style&index=0&id=f691b16e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f691b16e"]])

export default __exports__